<div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px" class="column">
    <h1>Choose Your Award</h1>
    <button mat-raised-button color="primary" routerLink="/TOY/login">Teacher and SRE of the Year</button>
    <button mat-raised-button color="primary" routerLink="/FACE/login">About Face</button>
    <button mat-raised-button color="primary" routerLink="/VOL/login">Volunteer of the Year</button>
    <button mat-raised-button color="primary" routerLink="/HOF/login">Hall of Fame</button>
</div>
